export default "__VITE_ASSET__CwtIY7K7__"